module.exports = __webpack_public_path__ + "media/images/webpage/hotels/743/service-340f6d136a5b93515297e09be090e563.webp";